module.exports = __webpack_public_path__ + "static/xxpeed-xp-3-038132ffa039e37a3498de3b5112ec1a.jpg";